import { IFormErrors } from '@interfaces/IFormsErrors';
import { IPeriodResults, IPeriodStudent } from '@interfaces/IPeriodResults';

export interface IStudentPerformanceState {
  studentPerformance: IPeriodResults | null;
  currentStudent: IPeriodStudent | null;
  isLoading: boolean;
  errors: IFormErrors | null;
}

export const initialsStudentPerformanceState: IStudentPerformanceState = {
  studentPerformance: null,
  currentStudent: null,
  isLoading: false,
  errors: null,
};
